module.exports = __webpack_public_path__ + "media/images/enterprise-type-0d4507861712e90215e16c2fb4afe0d4.png";